import React, { useState, useEffect } from 'react';
import { Loader2, Phone } from 'lucide-react';
import { DynamicForm } from './DynamicForm';

const API = process.env.REACT_APP_BACKEND_URL;

export const FormDinamico = ({ formKey }) => {
  const [def, setDef] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    fetch(`${API}/api/forms/${formKey}`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setDef)
      .catch(() => setErr(true));
  }, [formKey]);

  if (err) {
    return (
      <div className="text-center py-10" data-testid={`formdin-error-${formKey}`}>
        <p className="text-gray-600 mb-2">Il modulo non è al momento disponibile.</p>
        <p className="text-sm text-gray-500 flex items-center justify-center gap-1.5">
          <Phone size={14} /> Chiamaci allo 0785 747193 o scrivi a agenzia@assietica.it
        </p>
      </div>
    );
  }
  if (!def) {
    return (
      <div className="flex justify-center py-14" data-testid={`formdin-loading-${formKey}`}>
        <Loader2 size={28} className="animate-spin text-[#1B2380]" />
      </div>
    );
  }
  return <DynamicForm formKey={formKey} definition={def} />;
};
